import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { FeatureFlag } from '../models/feature-flag.model';

@Injectable({ providedIn: 'root' })
export class FeatureManagementService {
    private readonly http = inject(HttpClient);

    getFeatureFlags(): Observable<FeatureFlag[]> {
        const url = '/api/v1/feature-flags';
        return this.http.get<FeatureFlag[]>(url);
    }

    getPostAuthenticationFeatureFlags(): Observable<FeatureFlag[]> {
        const url = '/api/v1/session-feature-flags';
        return this.http.get<FeatureFlag[]>(url);
    }
}
